'use strict';


export class Calendar {
  constructor() {
    var input = `<input id="check" type="checkbox" class="online"  ${(window.location.href.indexOf("calendar-online") > -1) ? '' : 'checked'} /> `

    var checkbox = `
					<div class="switch-button-area">
						${input}
						<div class="switch">
							<span class="live">In Person</span>
							<span class="online">Online</span>
						</div>
					</div>
				`;

    $('.path-calendar #block-pagetitle-2 .page-title').append(checkbox);
    $('.path-calendar-online #block-pagetitle-2 .page-title').append(checkbox);
    $('#block-pagetitle-2 .page-title .switch-button-area').on('click', function () {
      $('#check').prop('checked', ($('#check').prop('checked') == true) ? false : true);
      setTimeout(() => {
        if ($('#check').prop('checked') == false) {
          window.location.href = "/calendar-online"
        } else {
          window.location.href = "/calendar";
        }
      }, 1000);
    });
  }
}
